import { styled } from '@mui/material/styles';
import { TableCell, tableCellClasses } from '@mui/material';

// スタイル付きのTableCell
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.grey[200],
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
  },
  '&.highlight': {
    backgroundColor: theme.palette.grey[100],
  },
  '&.total-row': {
    backgroundColor: theme.palette.grey[300],
    fontWeight: 'bold',
  },
  '&.header-yellow': {
    backgroundColor: '#FFF9C4',
    fontWeight: 'bold',
  },
  '&.expenses': {
    backgroundColor: '#CFD8DC', // 薄い青灰色
    color: '#333',
  },
  '&.yellow-cell': {
    backgroundColor: '#FFF9C4',
  },
  '&.pink-cell': {
    backgroundColor: '#FFCDD2',
  },
  '&.green-cell': {
    backgroundColor: '#C8E6C9',
  },
  '&.gray-cell': {
    backgroundColor: '#EEEEEE',
  },
}));